// @flow
import React, { useContext } from 'react';

import { addTranslationKeys } from 'Src/i18n';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { mapCategories } from 'Client/cms/toolkit/product-utils/productFeatures.utils';
import { productWellnessDetailQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';
import ReactAppContext from 'Context/ReactAppContext';
import { useRouter } from 'Client/router/useRouter';
import { WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES } from 'Utils/request/requestDictionary';
import { TRACKING_PREFIX_MAPPING } from 'Utils/tracking/resort';

import { ProductFeatures } from 'Components/widgets//product-features/ProductFeatures.jsx';
import { ProductFeatureDetail } from 'Components/widgets/product-feature-detail/ProductFeatureDetail.jsx';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';

export const ProductWellnessLine = (props: ProductWellnessLineProps) => {
  const {
    config: {
      common: { loadLess, onDemandService, scrollBackward, scrollForward, viewMore },
    },
    id,
    resort: {
      categories: { wellness },
      wellnessActivitiesIntroduction = {},
    },
  } = props;

  const { location } = useRouter<UrlParams, QueryParams>();
  const appContext = useContext(ReactAppContext);

  const fetchActivityServices = ({ productId, activityId }) => {
    const query = productWellnessDetailQuery(productId, activityId, {
      lineProps: props,
      urlParams: location.urlParams,
    });

    return graphQLClient
      .runQuery(query, appContext, {
        requestName: WIDGET_PRODUCT_ACTIVITIES_FETCH_SERVICES,
      })
      .then(data => {
        addTranslationKeys(data.config);

        return {
          productActivities: {
            ...data.productActivities,
            includedServices: data.includedServices,
            onDemandServices: data.onDemandServices,
          },
        };
      });
  };

  const introduction = {
    seeLessLabel: loadLess,
    seeMoreLabel: viewMore,
    text: wellnessActivitiesIntroduction.description,
    title: wellnessActivitiesIntroduction.shortDescription,
  };

  const productActivitiesCategories =
    wellness && wellness.filter(({ activities = [] }) => activities.length);

  const productCategories = mapCategories({
    fetchActivityServices,
    hasBanner: false,
    labelGAPrefix: TRACKING_PREFIX_MAPPING.WELLNESS,
    notIncludedMessage: onDemandService,
    productActivitiesCategories,
    productFeaturesLineData: props,
  });

  return (
    <SiteContainer className="Line" id={id}>
      <ProductFeatures
        categories={productCategories}
        introduction={introduction}
        labelGAPrefix={TRACKING_PREFIX_MAPPING.WELLNESS}
        queryLayer="productWellnessLayer"
        renderDetail={data => <ProductFeatureDetail {...data} />}
        scrollBackwardLabel={scrollBackward}
        scrollForwardLabel={scrollForward}
      />
    </SiteContainer>
  );
};
